module.exports = __webpack_public_path__ + "img/banana-outlet-wh.088cf15a.svg";